import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'
import MeetingExchangeButton from './MeetingExchangeButton'
import Tag from './Tag'

class TopicElement extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      moreInfoOpen: false,
      trimBodyText: '',
      saved: '',
      showing: '',
      setMeetingTopics: '',
      meetingId: ''
    }

    this.renderTags = this.renderTags.bind(this)
    this.moreInfo = this.moreInfo.bind(this)
    this.renderMoreInfoSection = this.renderMoreInfoSection.bind(this)
    this.pressStar = this.pressStar.bind(this)
    this.renderText = this.renderText.bind(this)
  }


  componentWillUnmount() {
    this.setState({
      showing: false,
      setMeetingTopics: false,
      meetingId: '',
    })
  }

  componentWillMount() {

    let trimBodyText = this.props.topic.body.substring(0, 100)
    if(this.props.topic.body.length > 100) {
      trimBodyText = `${trimBodyText}...`
    }
    this.setState({
      trimBodyText: trimBodyText,
    })
  }

  componentDidMount() {

      let anim = lottie.loadAnimation({
        container: document.getElementById(`fav-star${this.props.topic.id}`),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: `fav-star${this.props.topic.id}`,
        path: this.props.favoriteStarLottie,
      })

      if(this.props.selectedTags) {
        if(this.props.selectedTags.includes(this.props.topic.id)) {
          lottie.play(`fav-star${this.props.topic.id}`)

          this.setState({
            showing: true
          })
        }

        this.setState({
          saved: this.props.selectedTags.includes(this.props.topic.id)
        })
      }

    //if meetingId is present, check to see if user has already added to their Lex
    if(this.props.meetingId) {
      this.setState({
        setMeetingTopics: true,
        meetingId: this.props.meetingId
      })
    }

  }

  renderTags() {
    if(this.props.topic.tags != undefined) {
      let tags = this.props.topic.tags.map((tag, i) => {
        return <Tag tag={tag} key={i} selected={true}/>
      })
      return tags
    }
    return null
  }

  moreInfo() {
    this.setState({
      moreInfoOpen: !this.state.moreInfoOpen
    })
  }

  renderMoreInfoSection() {
    return(
      <div style={{textAlign: 'right', marginTop: 12, marginBottom: 12}}>
        <div style={{display: 'flex', flexDirection: 'row', textAlign: 'right', justifyContent: 'flex-end', alignItems: 'center'}}>
          {this.props.topic.users != undefined && <h5 style={{fontWeight: 100, marginRight: 5}}>{this.props.topic.users.length + 1} people practice this</h5>}
        </div>
        <div onClick={() => window.location.assign(`/profile/${this.props.topic.user.slug}`)} style={{display: 'flex', flexDirection: 'row', textAlign: 'right', justifyContent: 'flex-end', alignItems: 'center'}}>
          <h5 style={{fontWeight: 100, marginRight: 5}}>Created by</h5>
          <img src={this.props.topic.user.avatar_url} style={{height: 30, width: 30, borderRadius: 15}}/>
        </div>
        {this.props.topic.app_only === true &&
          <div>
            <h4 className="red bold" style={{textAlign: 'center'}}>Only available on the mobile app.</h4>
            <h5 style={{textAlign: 'center'}}>*Download beta app on Home dashboard*</h5>
          </div>
        }
      </div>
    )
  }

  pressStar() {
    if(this.state.saved) {
      lottie.setDirection(-1)

      lottie.play(`fav-star${this.props.topic.id}`)
      $.ajax({
        url: `../exchanges/${this.props.topic.id}/unfavorite`,
        dataType: 'JSON',
        type: 'POST',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.props.unfavoriteTopic(this.props.topic.id)
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    } else {
      lottie.play(`fav-star${this.props.topic.id}`)
      $.ajax({
        url: `../exchanges/${this.props.topic.id}/favorite`,
        dataType: 'JSON',
        type: 'POST',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.props.favoriteTopic(this.props.topic.id)
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }
    this.setState({
      saved: !this.state.saved
    })
  }

  renderText() {
    if(this.state.moreInfoOpen) {
      return this.props.topic.body.split(/(?:\r|\n)/g).map(function(line, index) {
        return(
          <h4 key={index} style={{ textAlign: 'left', fontWeight: 200, minHeight: 10}}>{line}</h4>
        )
      })
    } else {
      const count = 0
      return this.state.trimBodyText.split(/(?:\r\n|\r|\n)/g).map(function(line, index) {
        if(count < 3) {
          let count = count+1
          return(
            <h4 key={index} style={{textAlign: 'left', fontWeight: 200}}>{line}</h4>
          )
        } else {
          return null
        }
      })
    }
  }

  render() {
    return(
      <div className="topic_element_container">
        <h4 style={{textAlign: 'center', fontWeight: 600, marginBottom: 12}}>{this.props.topic.title}</h4>
        {this.props.favoriteStarLottie && <div
          onClick={() => this.pressStar()}
          id={`fav-star${this.props.topic.id}`}
          className="fav_star">
        </div>}
        <div style={{minHeight: 50}}>
        {this.renderText()}
        </div>
        {this.state.moreInfoOpen && this.renderMoreInfoSection()}
        <button
          style={{float: 'right', color: '#03A9F4', fontSize: 14}}
          onClick={() => this.moreInfo()}>
          {this.state.moreInfoOpen ? "- Less Info" : "+ More Info"}
        </button>
        <div style={{display: 'flex', flexWrap: 'wrap', marginTop: 18, marginLeft: -5, width: '100%'}}>
          {this.renderTags()}
        </div>

        {this.state.setMeetingTopics && <MeetingExchangeButton meetingId={this.state.meetingId} topicId={this.props.topic.id}/>}
      </div>
    )
  }


}

export default TopicElement;
